import React, { useState } from 'react'
import "./Navbar.css"
import { Link } from "react-router-dom"
import {FaBars,FaTimes} from "react-icons/fa"

const Navbar = () => {
  const [click,setClick] = useState(false);
  const [scrolled, scrolled_active] = useState(false);
const handleClick = ()=>{
  setClick(!click);
}

  const setScrolled = () => {
    if (window.scrollY >= 1) {
      scrolled_active(true);
    }
    else {
      scrolled_active(false);
    }
  }
  window.addEventListener("scroll", setScrolled);

  return (
    <>
      <nav className={scrolled ? "navbar navbar-bg" : "navbar"}>
        <a href='#about'>
          <h1>Portfolio</h1>
        </a>
        <ul className={click?'nav_menu active':'nav_menu '}>
          <li>
            <a href='#about' className='navbar_items' onClick={handleClick} >Home</a>
          </li>
          <li>
            <a href="#skills" className='navbar_items' onClick={handleClick} >Skills</a>
          </li>
          <li>
            <a href="#projects" className='navbar_items' onClick={handleClick} >Projects</a>
          </li>
          <li>
            <a href="#contact" className='navbar_items' onClick={handleClick} >Contact</a>
          </li>
        </ul>
        <div className="hamburger">
          {click ?  (<FaTimes size={20} style={{color:"#fff "}} onClick={handleClick}/>
          ):
           (<FaBars size={20} style={{color:"#fff "}} onClick={handleClick}/>)
           }
        </div>
      </nav>

    </>
  )
}

export default Navbar;